/* @flow */

import {createSelector} from 'reselect';
import {getUIState} from '../ui-selectors';
import type {NutshellState} from '../../store';

const getCreatorState = createSelector([getUIState], (uiState) => uiState.creator);

export const getFlashMessages = (state: NutshellState) => getCreatorState(state).flashMessages;
